var _rect, _path, _path2, _ellipse, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientDefaultAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    width: 130,
    height: 130,
    role: "img",
    "aria-label": "Default patient avatar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "#A9D8D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 130c0-21.5 20.1-33 45-33s45 11.5 45 33z",
    fill: "#7C8DA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 79h20v22a10 10 0 0 1-20 0z",
    fill: "#F2C1A6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 57,
    rx: 24,
    ry: 27,
    fill: "#F7D2B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26c-15.5 0-26 10.4-26 25 0 4.6.8 8.8 2.1 12.3l3.7-14.6c13.4 1.6 27.9-1.4 37.5-8.4l4.6 23a41 41 0 0 0 4.1-12.3c0-14.6-10.5-25-26-25z",
    fill: "#3F4A63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientDefaultAvatar);
export default __webpack_public_path__ + "static/media/patient_default_avatar.feb4072354a699b3d8ca202ff9a47ebc.svg";
export { ForwardRef as ReactComponent };